import { v4 as uuidv4 } from "uuid";
import { NetworkError } from "@/interfaces/errors/networkError";
import { UserDetails } from "@/interfaces/userDetails";

const BACKEND_URL = process.env.NEXT_PUBLIC_BACKEND_URL ?? "";

export const UpdateProfileInfos = (
  customerData: UserDetails,
  accessToken?: string
) => {
  const requestHeaders: HeadersInit = new Headers();
  requestHeaders.append("x-request-id", uuidv4());
  requestHeaders.append("x-api-key", process.env.NEXT_PUBLIC_BFF_API_KEY ?? "");
  requestHeaders.append("Content-Type", "application/json");
  if (accessToken !== undefined) {
    requestHeaders.append("Authorization", `Bearer ${accessToken}`);
    requestHeaders.append("Accept", "/");
  }

  return fetch(`${BACKEND_URL}/customers/v1`, {
    method: "PUT",
    headers: requestHeaders,
    body: JSON.stringify(customerData),
  }).then((response) => {
    if (!response.ok) {
      throw new NetworkError(
        `Request returned error ${response.status}`,
        response.status
      );
    }

    const contentType = response.headers.get("content-type");

    if (contentType?.includes("application/json")) {
      return response.json();
    } else {
      // calling response.json() with empty response body would throw
      return Promise.resolve({});
    }
  });
};
